export default class ExperimentVariant {
    /**
     * Constructor
     * @param experimentCode
     * @param variantCode
     * @param variantPayload
     */
    constructor(experimentCode, variantCode, variantPayload) {
        this.experimentCode = experimentCode;
        this.variantCode = variantCode;
        this.variantPayload = variantPayload;
    }
}
